import { action, payload } from 'ts-action'
import { IShift, IShiftApplicants } from 'models/Shift'
import { IError, IPayload } from 'models/Global'
import { IFavorite } from 'models/Favorite'

interface IUpshifterShiftsUpdateApplicants {
  applicants: IShiftApplicants
  shiftId: number
}

export const UpshifterShiftsFetching = action(
  'UpshifterShiftsFetching',
  payload<boolean>(),
)

export const GetUpshifterShifts = action(
  'GetUpshifterShifts',
  payload<IPayload<IShift[]>>(),
)

export const GetUpshifterShiftsWithoutConcat = action(
  'GetUpshifterShiftsWithoutConcat',
  payload<IPayload<IShift[]>>(),
)

export const GetUpshifterShiftsErrors = action(
  'GetUpshifterShiftsErrors',
  payload<IError>(),
)

export const ClearUpshifterShiftsReducer = action('ClearUpshifterShiftsReducer')

export const UpshifterShiftsSetHasMore = action(
  'UpshifterShiftsSetHasMore',
  payload<boolean>(),
)

export const UpshifterShiftsUnfavoriteBusiness = action(
  'UpshifterShiftsUnfavoriteBusiness',
  payload<number>(),
)

export const UpshifterShiftsFavoriteBusiness = action(
  'UpshifterShiftsFavoriteBusiness',
  payload<IFavorite>(),
)

export const UpshifterShiftsUpdateApplicants = action(
  'UpshifterShiftsUpdateApplicants',
  payload<IUpshifterShiftsUpdateApplicants>(),
)

export const UpshifterShiftsUpdateShift = action(
  'UpshifterShiftsUpdateShift',
  payload<IShift>(),
)

export const UpshifterShiftsRemoveShift = action(
  'UpshifterShiftsRemoveShift',
  payload<number>(),
)
